import PaymentOptionsPage from "./PaymentOptionsPage";

export default PaymentOptionsPage;
